// Loan-product-aware amount helpers used by every referral / apply form.
// Kept next to loanIcons because callers usually import both together.

import { LoanIcon } from "@/lib/loanIcons";

export { LoanIcon };

const inrShort = (n) => {
  const v = Number(n || 0);
  if (v >= 10000000) return `₹${(v/10000000).toFixed(2).replace(/\.00$/,"")} Cr`;
  if (v >= 100000)   return `₹${(v/100000).toFixed(2).replace(/\.00$/,"")} L`;
  if (v >= 1000)     return `₹${(v/1000).toFixed(1).replace(/\.0$/,"")}K`;
  return `₹${v.toLocaleString("en-IN")}`;
};

/** Find a loan doc in a `/api/loans` array by product name (case-insensitive). */
export function findLoan(loans, name) {
  if (!loans || !name) return null;
  const needle = String(name).toUpperCase();
  return loans.find(l => (l?.name || "").toUpperCase() === needle) || null;
}

/** { min, max } — nulls if the product has no bound. */
export function loanBounds(loan) {
  const min = Number(loan?.min_amount || 0);
  const max = Number(loan?.max_amount || 0);
  return { min: min > 0 ? min : null, max: max > 0 ? max : null };
}

/** Human helper text for the amount input, or null if the product has no bounds. */
export function loanRangeLabel(loan) {
  const { min, max } = loanBounds(loan);
  if (min && max) return `Range: ${inrShort(min)} – ${inrShort(max)}`;
  if (min) return `Min: ${inrShort(min)}`;
  if (max) return `Max: ${inrShort(max)}`;
  return null;
}

/**
 * Clamp `value` into the product's allowed range. Returns the clamped string
 * plus a `changed` flag so callers can flash a "Adjusted to max ₹X" toast.
 */
export function clampAmount(value, loan) {
  const raw = String(value || "").replace(/\D/g, "");
  if (!raw) return { value: "", changed: false, why: null };
  const v = Number(raw);
  const { min, max } = loanBounds(loan);
  if (min && v < min) return { value: String(min), changed: true, why: `Adjusted to min ${inrShort(min)}` };
  if (max && v > max) return { value: String(max), changed: true, why: `Adjusted to max ${inrShort(max)}` };
  return { value: String(v), changed: false, why: null };
}
